import { render, staticRenderFns } from "./IssueVarAutocomplete.vue?vue&type=template&id=2e913cfa&"
import script from "./IssueVarAutocomplete.vue?vue&type=script&lang=js&"
export * from "./IssueVarAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports